import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';

// Until the theme is typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => ({
  field: {
    height: '10vh',
    marginBottom: '1.3vh',
    fontSize: rem(1.5),
    width: '35vw',
  },
  formBottomMargin: {
    marginBottom: '7vh',
  },
  singleFieldTopMargin: {
    marginTop: '8vh',
  },
  formTitle: {
    color: theme.defaultTextColor,
    marginRight: 'auto',
    marginLeft: '2vw',
    fontSize: vh(2.34),
  },
  validationTitleGrid: {
    fontSize: vh(4.18),
    color: theme.modalTitle,
    fontWeight: 500,
  },
  validationDividerGrid: {
    width: '100%',
  },
  validationDivider: {
    color: theme.infoMain,
    borderTop: '10px solid #264558',
    width: '4.85vw',
    margin: '3vh auto',
  },
}));
